exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-wrapper-frame[data-v-670263cd]{padding:10px;width:80vw;margin:auto !important;margin-top:20px !important;border-radius:10px;box-shadow:1px 1px 20px 5px rgba(0,0,0,.2)\n}\n.test[data-v-670263cd]{display:block\n}\n.test div[data-v-670263cd]{margin-bottom:60px;line-height:10px\n}\n.turn-off-google-info[data-v-670263cd]{margin-left:20px;font-size:1.3em\n}\n@media(max-width: 1106px){\n.turn-off-google-info[data-v-670263cd]{font-size:1.1em\n}\n}\nh4[data-v-670263cd]{text-transform:uppercase\n}\n.imgContainer[data-v-670263cd]{display:flex;justify-content:end\n}\n.imgContainer img[data-v-670263cd]{margin-right:20px;width:250px\n}\n@media(max-width: 1106px){\n.imgContainer img[data-v-670263cd]{width:150px\n}\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-670263cd","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/spa/partnerIntegrations/Profile.vue
// module id = 116
// module chunks = 0